import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatInput } from '@angular/material/input';
import { debounceTime, tap, switchMap, finalize, map } from 'rxjs/operators';
import { CNUser } from 'src/app/models/cnuser';
import { UserConfigService } from 'src/app/services/user-config.service';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-user-selection',
  templateUrl: './user-selection.component.html',
  styleUrls: ['./user-selection.component.scss']
})
export class UserSelectionComponent implements OnInit, AfterViewInit {

  @Input() label = 'Utilisateur';
  @Input() mode = 'option';
  @Input() userClass;
  @Input() allowAdd = false;
  @Input() searchUserGroups = false;
  @ViewChild('textInput') textInput: ElementRef;

  @Output() selected: EventEmitter<CNUser> = new EventEmitter();

  public selectedUser: CNUser;
  public searchUserCtrl = new UntypedFormControl({disabled: true});
  public filteredUsers: CNUser[] = [];
  public isLoading = false;
  public errorMsg: string;
  public description: string;

  private userWasSet = false;
  private userGroups = [];

  constructor(private userService: UserService, private userConfig: UserConfigService) { }

  ngOnInit(): void {
    // get user groups
    if (this.userConfig.config && this.userConfig.config.groups &&
        this.userConfig.config.groups.length !== 0) {
      for (const group of this.userConfig.config.groups) {
        this.userGroups.push(group.name);
      }
    }
    this.searchUserCtrl.valueChanges
      .pipe(debounceTime(500))
      .subscribe(value => {
          this.errorMsg = '';
          this.filteredUsers = [];
          if (value && value.length > 0 && !this.userWasSet && value !== this.description) {
            this.isLoading = true;
            console.log('tap', value, this.userWasSet, this.isLoading);
            // start searching
            setTimeout(() => {
              this.userService.search(value, this.userClass, this.searchUserGroups ? this.userGroups : undefined).subscribe(users => {
                this.filteredUsers = users;
                this.isLoading = false;
              }, error => {
                this.isLoading = false;
              });
            });
          }
          if (this.userWasSet) {
            this.userWasSet = false;
          }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.textInput.nativeElement.classList.remove('mat-focused');
//      this.searchUserCtrl
    }, 100);
  }

  @Input() set user(auser: CNUser) {
    this.selectedUser = auser;
    if (this.selectedUser) {
      this.description = this.selectedUser.firstname + ' ' + this.selectedUser.lastname;
      this.userWasSet = true;
      this.searchUserCtrl.setValue(this.description);
    }
  }

  get user(): CNUser {
    return this.selectedUser;
  }

  displayUser(user): string {
    if (!user) {
      return '';
    }
    if (user instanceof CNUser) {
      return user.firstname + ' ' + user.lastname;
    }
    if (typeof user === 'string') {
      return user;
    }
    return '';
  }

  selectUser(user: CNUser) {
    this.selectedUser = user;
    if (this.selectedUser) {
      this.description = this.selectedUser.firstname + ' ' + this.selectedUser.lastname;
      this.searchUserCtrl.setValue(this.description);
    }
    this.selected.emit(user);
  }

  style() {
    if (this.mode === 'admin') {
      return 'height:80px;border-bottom: 1px gray solid;';
    }
    if (this.mode === 'list') {
      return 'height:150px;border-bottom: 1px gray solid;';
    }
    return 'height:150px;border-bottom: 1px gray solid;';
  }
}
